import React from 'react';
import styled from 'styled-components';
import { Flex } from '../Layout/Layout';

const ContentWrapper = styled(Flex)`
  position: relative;
  width: 100%;
  min-height: 100%;
`;

function LargeContent({ children }) {
  return (
    <ContentWrapper width={1} flex="1 1 auto" as="div">
      {children}
    </ContentWrapper>
  );
}

export default LargeContent;
